import {Component, Input, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import { Http} from "@angular/http";
import { ToasterService} from 'angular2-toaster/angular2-toaster';
import {BatchPaymentClientsModel, DataForProcessModel} from '../../../../models/batch-payments/batch-payments.model';
import {BatchPaymentsService} from '../../../../models/batch-payments/batch-payments.service';
import {ClientAccountsService} from '../../../../models/client-accounts/client-accounts.service';
import {ClientAccountsModel} from '../../../../models/client-accounts/client-accounts.model';
import {UsersService} from "../../../../models/users/users.service";
import {DebtsService} from "../../../../models/debts/debts.service";
import {Observable} from 'rxjs/Observable';

import {phoneFormatter} from "../../../../helpers/phone-format";

@Component({
    selector: 'processing-item',
    templateUrl: 'processing-item.template.html',
    styleUrls: ['processing-item.css']
})
export class ProcessingItemComponent implements OnInit {
    phoneFormatter = phoneFormatter;

    @ViewChild('confirmForceProcess') public confirmForceProcess;

    @Input()
    public client = <BatchPaymentClientsModel|any> {};

    @Output() onSuccessProcess: EventEmitter<any> = new EventEmitter<any>();

    public checkedVoidedTransactions : Array<any> = [];
    public checkedUnchargedTransactions : Array<any> = [];
    public selectedAccountId = null;

    public addTransactionAccountId = null;
    public addTransactionAmount = 0;
    public addTransactionDate: any = null;

    public reason: String = "";

    public accounts = <ClientAccountsModel[]> [];

    public tagNames: any = ['', 'Authorized processor', 'Ubereats', 'Skipthedishes', 'Miscellaneous'];
    public paymentTagName: any = '';

    public readyToBeProcessed = [];
    public checkedReadyToBeProcessed : Array<any> = [];

    public manualPaymentAmount = 0;

    public date = null;
    public dateReady = null;

    public errors: Array<any> = [];
    public dataForProcess = <DataForProcessModel|any> {};

    @Input()
    public dataChange: Observable<Array<any>>;

    public onlyProcessed: boolean;

    private _is_process_now = false;

    constructor(
        private router: Router,
        private batchPaymentsService: BatchPaymentsService,
        private clientAccountsService: ClientAccountsService,
        private debtsService: DebtsService,
        public Users: UsersService,
        public http: Http,
        private toasterService: ToasterService)
    {
        this.Users = new UsersService(this.http);
    }

    get isProcessNow() {
        return this._is_process_now;
    }

    get isCanReadyProcess() {
        return this.checkedReadyToBeProcessed.length > 0.1 && ! this._is_process_now;
    }

    get isCanProcess() {
        return ! this._is_process_now;
    }


    ngOnInit() {
        this.getClientAccounts(this.client.id);


        if (this.dataChange) {
            this.dataChange.subscribe((batch) => {
                this.createReadyToBeProcessed(batch);
            });
        }

        if (! this.client.debt) {
            this.batchPaymentsService
                .getList({client_id: this.client.id})
                .subscribe((res) => {
                    let client = res.data.filter(item => {
                        if(item.id == this.client.id) return true;
                    });

                    this.client = client[0];
                });
        }
    }

    public createReadyToBeProcessed(batch) {

        this.getClientAccounts(this.client.id);

        let clientId = this.client.id;
        this.readyToBeProcessed = [];

        batch.forEach((obj) => {
            if (obj.client_id == clientId) {
                this.readyToBeProcessed.push(obj);
            }
        });

    }

    isProcessed(transaction) {
        return transaction.processed > 0 ? true : false;
    }

    toggleReadyTransaction(transaction) {
        if (this.isProcessed(transaction)) return;
        if (this.checkedReadyToBeProcessed[transaction.id]) {
            delete this.checkedReadyToBeProcessed[transaction.id];
        } else {
            this.checkedReadyToBeProcessed[transaction.id] = {
                amount: Math.round(transaction.amount * this.client.debt.percentage* 100) / 100
            }
        }
    }

    public toggleOnlyProcessed() {
        this.onlyProcessed = !this.onlyProcessed;
    }


    getReadyTotal() {
        let total = 0;

        for(let i in this.checkedReadyToBeProcessed) {
            total += parseFloat(this.checkedReadyToBeProcessed[i].amount);
        }

        return total;
    }



    toggleVoidedTransaction(transaction) {
        if (this.checkedVoidedTransactions[transaction.id]) {
            delete this.checkedVoidedTransactions[transaction.id];
        } else {
            this.checkedVoidedTransactions[transaction.id] = {
                amount: Math.round(transaction.amount * this.client.debt.percentage * 100) / 100
            }
        }
    }


    getVoidedTotal() {
        let total = 0;

        for(let i in this.checkedVoidedTransactions) {
            total += parseFloat(this.checkedVoidedTransactions[i].amount);
        }

        return total;
    }


    toggleUnchargedTransaction(transaction) {
        if (this.checkedUnchargedTransactions[transaction.id]) {
            delete this.checkedUnchargedTransactions[transaction.id];
        } else {
            this.checkedUnchargedTransactions[transaction.id] = {
                amount: transaction.amount
            }
        }
    }


    getUnchargedTotal() {
        let total = 0;

        for(let i in this.checkedUnchargedTransactions) {
            total += parseFloat(this.checkedUnchargedTransactions[i].amount);
        }

        return total;
    }

    loadPendingTransactions() {

        if (this.client.id && this.selectedAccountId) {
            this.batchPaymentsService.getPendingTransactions(this.client.debt.id, this.selectedAccountId)
                .subscribe((res) => {
                    this.readyToBeProcessed = res.data;
                })
        } else {
            this.readyToBeProcessed = [];
        }
    }

    getClientAccounts(clientId) {
        this.clientAccountsService.getListByClient(clientId)
            .subscribe((res) => {
                this.accounts = res.data;
            });
    }

    setSelectedAccount() {
        this.loadPendingTransactions();
    }

    getTotal() {
        return  this.getVoidedTotal() + this.getUnchargedTotal() + (parseFloat(<any> this.manualPaymentAmount) || 0);
    }

    addTransaction() {
        this.debtsService.addTransaction({account_id: this.addTransactionAccountId,
            amount: this.addTransactionAmount, client_id: this.client.id, date: this.addTransactionDate})
            .subscribe((res) => {
                this.createReadyToBeProcessed([res.data]);
                [this.addTransactionAmount, this.addTransactionAccountId] = [0, 0];
                this.addTransactionDate = null;
            });
    }

    processReady(isForce: any = false) {
        if (this._is_process_now) return;
        this._is_process_now = true;

        this.dataForProcess.debt_id = this.client.debt.id;
        this.dataForProcess.client_debt_id = this.dataForProcess.debt_id;
        this.dataForProcess.amount = "";
        this.dataForProcess.reason = '';
        this.dataForProcess.payment_date = this.getDateByDate(this.dateReady);

        this.dataForProcess.nsfs = [];
        this.dataForProcess.transactions = {};
        this.dataForProcess.transactions_list = [];
        this.dataForProcess.transactions_amount = [];
        this.dataForProcess.will_nsf = false;
        this.dataForProcess.nsf_value = 0;
        
        this.dataForProcess.paymentTagName = this.paymentTagName;

        this.checkedReadyToBeProcessed.forEach((item, index) => {
            let id = index;
            var amount = parseFloat(item.amount);
            this.dataForProcess.transactions_list.push(id);
            this.dataForProcess.transactions_amount.push(amount);
            this.dataForProcess.transactions[id] = amount;

        });

        this.dataForProcess._with_allowed_negative_balance = isForce ? true : false;

        this.debtsService.processPendingTransactions({'info': this.dataForProcess})
            .subscribe((res) => {
                this.dateReady = "";
                this.checkedReadyToBeProcessed = [];
                this.readyToBeProcessed = [];
                this.selectedAccountId = null;
                this.paymentTagName = '';
                this.toasterService.pop('success', 'Success', 'Transactions are processed');

                this.batchPaymentsService.getList({client_id: res.data.client_id})
                    .subscribe((res) => {
                        let client = res.data.filter(item => {
                            if(item.id == this.client.id) return true;
                        });
                        this.client = client[0];
                    }, (err) => {
                        this.toasterService.pop('error', 'Error', 'An error occured');
                    });
                this._is_process_now = false;
            }, err => {
                let error_msg: any;
                try {
                    let errorData = JSON.parse(err._body);
                    error_msg = errorData.errors[0];
                    if (! error_msg) throw 'empty msg';
                } catch (e) {
                    error_msg = 'An error occured';
                }
                this.toasterService.pop('error', 'Error', error_msg);
                if (error_msg.search(/Negative/uig) > -0.5) {
                    this.confirmForceProcess.onSuccess.subscribe(() => {
                        this.processReady(true);
                    });
                    this.confirmForceProcess.bodyLabel = 'Do you want to force the operation?';
                    this.confirmForceProcess.show(error_msg);
                }
                this._is_process_now = false;
            });
    }

    process(isForce: any = false) {
        if (this._is_process_now) return;
        this._is_process_now = true;

        this.dataForProcess.debt_id = this.client.debt.id;
        this.dataForProcess.client_debt_id = this.dataForProcess.debt_id;
        this.dataForProcess.amount = parseFloat(<any> this.manualPaymentAmount) || 0;
        this.dataForProcess.reason = this.reason || "";
        this.dataForProcess.payment_date = this.getDateByDate(this.date);

        this.dataForProcess.nsfs = [];
        this.dataForProcess.transactions = {};
        this.dataForProcess.transactions_list = [];
        this.dataForProcess.transactions_amount = [];
        this.dataForProcess.will_nsf = false;
        this.dataForProcess.nsf_value = 0;

        this.checkedVoidedTransactions.forEach((item, index) =>{
            let id = index;
            var amount = parseFloat(item.amount);
            this.dataForProcess.transactions_list.push(id);
            this.dataForProcess.transactions_amount.push(amount);
            this.dataForProcess.transactions[id] = amount;

        });


        this.checkedUnchargedTransactions.forEach((item, index) => {
            let id = index;
            this.dataForProcess.amount = parseFloat(item.amount);
            this.dataForProcess.nsfs.push(id);

        });

        this.dataForProcess._with_allowed_negative_balance = isForce ? true : false;

        this.dataForProcess.paymentTagName = this.paymentTagName;

        this.debtsService.processPendingTransactions({'info': this.dataForProcess})
            .subscribe((res) => {
                this.toasterService.pop('success', 'Success', 'Transactions are processed');
                this.clear();

                this.batchPaymentsService.getList({client_id: res.data.client_id})
                    .subscribe((res) => {
                        let client = res.data.filter(item => {
                            if(item.id == this.client.id) return true;
                        });

                        this.client = client[0];
                    });
                this._is_process_now = false;
            }, err => {
                let error_msg: any;
                try {
                    let errorData = JSON.parse(err._body);
                    error_msg = errorData.errors[0];
                    if (! error_msg) throw 'empty msg';
                } catch (e) {
                    error_msg = 'An error occured';
                }
                this.toasterService.pop('error', 'Error', error_msg);
                if (error_msg.search(/Negative/uig) > -0.5) {
                    this.confirmForceProcess.onSuccess.subscribe(() => {
                        this.process(true);
                    });
                    this.confirmForceProcess.bodyLabel = 'Do you want to force the operation?';
                    this.confirmForceProcess.show(error_msg);
                }
                this._is_process_now = false;
            });
    }

    public clear() {
        this.reason = "";
        this.manualPaymentAmount = 0;
        this.date = "";
        this.checkedVoidedTransactions = [];
        this.checkedUnchargedTransactions = [];
    }

    public cleanDate(str: any) {
        return str.replace(/T[\s\S]+$/g, '');
    }

    getDateByDate(date: any): any
    {
        let payment_date: any = date; 
        try {
            if (date) {
                payment_date = new Date('' + date + ' 12:00');
                if (! isFinite(payment_date)) throw 'Invalid date';
                payment_date = payment_date.toISOString();
            }
        } catch (e) {
            payment_date = date;
        }

        return payment_date;
    }


    save() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/accounting/processing/item/processing-item.component.ts